import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper, {
  continuousExtent,
  continuousExtentParts,
  cleanCollisions,
} from '../chart_helpers/AxisHelper'
import { categoricalExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import * as COLORS from '../utils/colorUtils'

import { extent as d3_extent } from 'd3-array'
import {
  curveCardinal as d3_curveCardinal,
  curveLinear as d3_curveLinear,
  line as d3_line,
} from 'd3-shape'
import SizeHelper from '../chart_helpers/SizeHelper'
import { dentedRect } from '../utils/pathUtils'

const MAX_BAR_WIDTH = 40
export default class LineAndBarChartChart extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = true
  }
  static defaultConfig = {
    /**
     * Type of curve. `smooth` curves will interpolate between the data poitns. `shapr` curves will be composed of straight line segments.
     */
    curve: {
      type: String,
      default: 'smooth',
      options: ['smooth', 'sharp'],
      exposed: true,
    },
    /**
     * Show/hide the data points that form each line.
     */
    showPoints: {
      type: Boolean,
      default: true,
      exposed: true,
    },
    /**
     * Show the value on top of each bar.
     */
    showBarDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    /**
     * Show the value of each point in the line.
     */
    showLineDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    ItemsHelper: {
      colorScale: {
        // me lo he llevado al "viz"
        // value: ['categorical', 'categorical'],
        // options:[['categorical','single'],['categorical','single']],
        // multiValueIds: ['lines', 'bars'],
      },
      colorMode: {
        value: ['stroke', 'fill'],
        multiValueIds: ['lines', 'bars'],
      },
      colorDict: {
        value: [null, null],
        multiValueIds: ['lines', 'bars'],
      },
    },
    AxisHelper: {
      x: {
        scale: 'band',
        getExtent: function (data) {
          return categoricalExtent(data.bars) //data.bars.map((d)=>d.id)
        },
      },
      y: {
        getExtent: function (data, dimLabel) {
          // "TIENEN QUE MATCHEAR LAS "SCALES""....
          let extent, extentParts
          if (dimLabel === 'y_lines') {
            extent = d3_extent(
              data.lines.reduce((res, d) => res.concat(d3_extent(d.value, dd => dd.value)), [])
            )
            extentParts = continuousExtentParts(data.lines)
            // console.log("line extent bef",extent)
            if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
              extent = cleanCollisions(this.axes.y_0, extent, extentParts)
              // NOSE COMO adaptar el cleancollisions para que mire en el "otro axis"...
              extent = cleanCollisions(this.axes.y_1, extent, extentParts)
              // console.log("line extent aft",extent)
            }
          } else if (dimLabel === 'y_bars') {
            extentParts = data.bars.map(d => ({ value: [d, d] }))
            extent = continuousExtent(data.bars)
            // console.log("bar extent bef",extent)
            if (this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit) {
              extent = cleanCollisions(this.axes.y_1, extent, extentParts)
              // NOSE COMO adaptar el cleancollisions para que mire en el "otro axis"...
              extent = cleanCollisions(this.axes.y_0, extent, extentParts)
              // console.log("bar extent aft",extent)
            }
          }
          return extent
        },
        dimensions: 'line-and-bar',
        valueFormat: {
          value: ['[N]0.0', '[N]0.0'],
          multiValueIds: ['lines', 'bars'],
        },
        unit: {
          value: ['line units', 'bar units'],
          multiValueIds: ['lines', 'bars'],
        },
        tickOrientation: {
          value: ['horizontal', 'horizontal'],
          multiValueIds: ['lines', 'bars'],
        },
      },
    },
    TooltipBehavior: {
      itemsKeys: ['linesItems', 'barsItems'],
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5
        }
      },
      getHtml: function (d, itemsKey) {
        console.log('should use onAxis', itemsKey)
        let onAxis = itemsKey === 'linesItems' ? 'y_0' : 'y_1'
        if (itemsKey === 'linesItems') {
          return `
            <div class="tip-value important">${this.valueWithUnit(d.value, onAxis)}</div>
            <div class="tip-id">
              <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
                { id: d.parentId },
                0
              )}; margin-right: 3px"></span>
              ${d.parentId}
            </div>
            <div class="secondary">${this.formatValue(d.id, 'x')}</div>
            `
        } else {
          return `
            <div class="tip-value important">${this.valueWithUnit(d.value, onAxis)}</div>
            <div class="tip-id">
              <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
                { id: d.id },
                1
              )}; margin-right: 3px"></span>
              ${d.id}
            </div>
            `
        }

        /*return `
          <span class="important">${this.valueWithUnit(d.value, onAxis)}</span>
          <br/>
          ${d.id}
        `*/
      },
    },
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    // {
    //   class: ItemsHelper,
    //   config:{
    //     colorScale: {
    //       value: ['categorical','categorical'],
    //       multiValueIds: ['lines','bars']
    //     },
    //     colorMode: {
    //       value: ['stroke','fill'],
    //       multiValueIds: ['lines','bars']
    //     },
    //     colorDict: {
    //       value: [null,null],
    //       multiValueIds: ['lines','bars']
    //     }
    //   }
    // },
    SelectableHelper,
    SizeHelper,
    AxisHelper,
    // {
    //   class: AxisHelper,
    //   config: {
    //     x:{
    //       scale: 'band',
    //       getExtent: function (data){
    //         return categoricalExtent(data.bars) //data.bars.map((d)=>d.id)
    //       }
    //     },
    //     y:{
    //       getExtent: function (data,dimLabel){
    //         // "TIENEN QUE MATCHEAR LAS "SCALES""....
    //         let extent,extentParts
    //         if(dimLabel === 'y_lines') {
    //           extent = d3_extent(data.lines.reduce((res,d)=>res.concat(d3_extent(d.value,(dd)=>dd.value)),[]))
    //           extentParts = continuousExtentParts(data.lines)
    //           // console.log("line extent bef",extent)
    //           extent = cleanCollisions(this.axes.y_0, extent, extentParts)
    //           // NOSE COMO adaptar el cleancollisions para que mire en el "otro axis"...
    //           extent = cleanCollisions(this.axes.y_1, extent, extentParts)
    //           // console.log("line extent aft",extent)
    //         } else if(dimLabel === 'y_bars') {
    //           extentParts = data.bars.map((d)=>({value:[d,d]}))
    //           extent = continuousExtent(data.bars)
    //           // console.log("bar extent bef",extent)
    //           extent = cleanCollisions(this.axes.y_1, extent, extentParts)
    //           // NOSE COMO adaptar el cleancollisions para que mire en el "otro axis"...
    //           extent = cleanCollisions(this.axes.y_0, extent, extentParts)
    //           // console.log("bar extent aft",extent)
    //         }
    //         return extent
    //       },
    //       dimensions: 'line-and-bar',
    //       valueFormat: {
    //         value: ['[N]0.0','[N]0.0'],
    //         multiValueIds: ['lines','bars']
    //       },
    //       unit: {
    //         value: ['line units','bar units'],
    //         multiValueIds: ['lines','bars']
    //       },
    //       tickOrientation: {
    //         value: ['horizontal','horizontal'],
    //         multiValueIds: ['lines','bars']
    //       },
    //     }
    //   }
    // }
  ]
  checkConsistency() {
    return true
  }
  draw() {
    let longDir = 'width'
    // let shortDir = 'height'
    let getTranslate = (long, short) => {
      return `translate(${long},${short})`
    }

    let linesScale = this.axes.y_0.func.scale()
    let barsScale = this.axes.y_1.func.scale()
    let xScale = this.axes.x.func.scale()

    let offsetValue
    if (barsScale.domain()[0] < 0 && barsScale.domain()[1] > 0) offsetValue = 0
    else offsetValue = barsScale.domain()[0]

    let getOffset = v => Math.min(v, barsScale(offsetValue))
    let getShort = v => Math.abs(barsScale(offsetValue) - v)

    let barPercent = 0.7
    // let barWidth = xScale.bandwidth()*barPercent
    // let barMargin = xScale.bandwidth()*(1-barPercent)/2
    let barWidth = Math.min(MAX_BAR_WIDTH, xScale.bandwidth() * barPercent)
    let barMargin = (xScale.bandwidth() - barWidth) / 2

    // this.barsItemsEnter.append('rect')
    this.barsItemsEnter.append('path')
    this.barsItemsEnter
      .attr('transform', d => getTranslate(xScale(d.id) + barMargin, getOffset(barsScale(0))))
      .select('path')
      .attr('fill', d => this.color(d, 1))
      .attr('d', d => {
        let w = longDir === 'width' ? barWidth : 0
        let h = longDir === 'width' ? 0 : barWidth
        let dent =
          longDir === 'width'
            ? d.value > 0
              ? ['tl', 'br']
              : 'bl'
            : d.value > 0
            ? ['bl', 'tr']
            : 'tr'
        return dentedRect(w, h, dent)
      })
    this.barsItemsEnterTrans
      .attr('transform', d => getTranslate(xScale(d.id) + barMargin, getOffset(barsScale(d.value))))
      .select('path')

      .attr('d', d => {
        let w = longDir === 'width' ? barWidth : getShort(barsScale(d.value))
        let h = longDir === 'width' ? getShort(barsScale(d.value)) : barWidth
        let dent =
          longDir === 'width'
            ? d.value > 0
              ? ['tl', 'br']
              : 'bl'
            : d.value > 0
            ? ['bl', 'tr']
            : 'tr'
        return dentedRect(w, h, dent)
      })
    this.barsItems.lower()
    this.barsItemsTrans
      .attr('transform', d => getTranslate(xScale(d.id) + barMargin, getOffset(barsScale(d.value))))
      // this.barsItems.select('rect').transition()
      //   .attr(longDir,()=>barWidth)
      //   .attr(shortDir,(d)=> getShort(barsScale(d.value)))
      //   .attr('fill',(d)=>this.color(d))
      .select('path')
      .attr('fill', d => this.color(d, 1))
      .attr('d', d => {
        let w = longDir === 'width' ? barWidth : getShort(barsScale(d.value))
        let h = longDir === 'width' ? getShort(barsScale(d.value)) : barWidth
        let dent =
          longDir === 'width'
            ? d.value > 0
              ? ['tl', 'br']
              : 'bl'
            : d.value > 0
            ? ['bl', 'tr']
            : 'tr'
        return dentedRect(w, h, dent)
      })

    this.barsItemsExitTrans.style('opacity', 0)

    // BAR DATUMS LABELS
    let datumValues = this.barsItemsEnter
      .merge(this.barsItems)
      .selectAll('.datum-value')
      .data(d => (this.config.showBarDatumValues ? [d] : []))
    datumValues.exit().transition().style('opacity', 0).remove()

    let datumValuesEnter = datumValues
      .enter()
      .append('g')
      .attr('class', 'datum-value')
      .style('opacity', 0)

    datumValuesEnter.append('rect')

    datumValuesEnter
      .append('text')
      .style('font-size', '14px')
      .style('font-weight', 'bold')
      .attr('fill', 'currentColor')

    datumValues = datumValues.merge(datumValuesEnter)

    datumValues.transition().style('opacity', 1)

    datumValues.select('text').text(d => this.formatValue(d.value, 'y_1'))

    datumValues
      .select('text')
      .attr('text-anchor', 'middle')
      .attr('x', barWidth / 2)
      .attr('y', -8)

    if (this.config.showBarDatumValues) {
      let bbox = datumValues.select('text').node().getBBox()
      datumValues
        .select('rect')
        .attr(
          'fill',
          this.config.skin === 'dark' ? 'rgba(31, 31, 31, 0.8)' : 'rgba(255,255,255,0.8)'
        )
        .attr('width', bbox.width + 4)
        .attr('height', bbox.height)
        .attr('x', barWidth / 2 - bbox.width / 2 - 2)
        .attr('y', -8 - bbox.height / 2 - 4)
        .attr('rx', 2)
    }

    ///////////////LINES//////////

    let line = d3_line()
      .curve(this.config.curve === 'smooth' ? d3_curveCardinal : d3_curveLinear)
      .x(d => xScale(d.id) + barMargin + barWidth / 2)
      .y(d => linesScale(d.value))

    let self = this
    this.linesParentItemsEnter
      .append('path')
      .attr('class', 'ghost-path')
      .attr('fill', 'none')
      .attr('stroke-width', d => this.thickness(d, 0) + 1)
      .attr(
        'stroke',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('d', d => line(d.value))
      .style('opacity', 0)

    this.linesParentItemsEnter
      .append('path')
      .attr('class', 'real-path')
      .attr('fill', 'none')
      .attr('stroke', d => this.color(d, 0))
      .attr('stroke-width', d => this.thickness(d, 0))
      .attr('d', d => line(d.value))
      .each(function () {
        this._totalLength = this.getTotalLength()
      })
      .attr('stroke-dasharray', function (d) {
        var dashing = self.strokeDasharray(d)
        if (dashing === 'none') dashing = '1 0'
        var dashLength = dashing
          .split(/[\s,]/)
          .map(function (a) {
            return parseFloat(a) || 0
          })
          .reduce(function (a, b) {
            return a + b
          })
        var dashCount = Math.ceil(this._totalLength / dashLength)
        var newDashes = new Array(dashCount).join(dashing + ' ')
        var dashArray = newDashes + ' 0, ' + this._totalLength
        return dashArray
      })
      .attr('stroke-dashoffset', function () {
        return this._totalLength
      })

    this.linesParentItemsEnterTrans.select('.ghost-path').style('opacity', 1)

    this.linesParentItemsEnterTrans.select('.real-path').attr('stroke-dashoffset', 0)

    this.linesParentItems.select('.real-path').attr('stroke-dasharray', 'none')

    this.linesParentItemsTrans
      .select('.real-path')
      .attr('stroke-dasharray', d => this.strokeDasharray(d, 0))
      .attr('stroke-width', d => this.thickness(d, 0))
    this.linesParentItemsTrans
      .select('.ghost-path')
      .attr('stroke-width', d => this.thickness(d, 0) + 1)

    this.linesParentItemsTrans.select('.real-path').attr('stroke', d => this.color(d, 0))

    this.linesParentItemsTrans.select('.real-path').attr('d', d => line(d.value))
    this.linesParentItemsTrans
      .select('.ghost-path')
      .attr('d', d => line(d.value))
      .attr(
        'stroke',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )

    this.linesParentItemsExitTrans.style('opacity', 0)

    this.linesParentItems.merge(this.linesParentItemsEnter).raise()

    // NO ESTA BIEN AUN...
    let linesItems = this.linesItems.merge(this.linesItemsEnter)
    let breakpoints = linesItems
      .raise()
      .selectAll('.break-point')
      .data(d => (this.config.showPoints && (d.value || d.value == 0) ? [d] : []))
    breakpoints.exit().transition().style('opacity', 0).remove()
    let breakpointsEnter = breakpoints.enter().append('g').attr('class', 'break-point')

    //dots to enlarge click area
    //breakpointsEnter.append('circle').attr('r', '20').attr('opacity', 0)

    breakpointsEnter.append('circle').attr('class', 'dot')
    breakpointsEnter.attr(
      'transform',
      d => `translate(${xScale(d.id) + barMargin + barWidth / 2},${linesScale(d.value)})`
    )

    this.linesItemsEnter
      .select('.break-point')
      .attr(
        'transform',
        d => `translate(${xScale(d.id) + barMargin + barWidth / 2},${linesScale(d.value)})`
      )
      .select('.dot')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }, 0))
      .attr('r', 0)
    this.linesItemsEnterTrans.select('.break-point').select('.dot').attr('r', 3)
    this.linesItemsTrans
      .select('.break-point')
      .attr(
        'transform',
        d => `translate(${xScale(d.id) + barMargin + barWidth / 2},${linesScale(d.value)})`
      )
      .select('.dot')
      .attr(
        'fill',
        this.config.skin === 'light' ? COLORS.SKIN_BACKGROUND : COLORS.SKIN_BACKGROUND_DARK
      )
      .attr('stroke', d => this.color({ id: d.parentId }, 0))
      .attr('r', 3)
    this.linesItemsExitTrans.select('.dot').attr('opacity', 0)

    // LINES DATUMS LABELS
    let lineDatumValues = breakpointsEnter
      .merge(breakpoints)
      .selectAll('.line-datum-value')
      .data(d => (this.config.showLineDatumValues ? [d] : []))
    lineDatumValues.exit().transition().style('opacity', 0).remove()
    let linesDatumValuesEnter = lineDatumValues
      .enter()
      .append('g')
      .attr('class', 'line-datum-value')
      .style('opacity', 0)

    linesDatumValuesEnter.append('rect')

    linesDatumValuesEnter
      .append('text')
      .style('font-size', '14px')
      .style('font-weight', 'bold')
      .attr('fill', 'currentColor')

    lineDatumValues = lineDatumValues.merge(linesDatumValuesEnter)

    lineDatumValues.transition().style('opacity', 1)

    lineDatumValues.select('text').text(d => this.formatValue(d.value, 'y_0'))
    lineDatumValues.select('text').attr('text-anchor', 'middle').attr('x', 0).attr('y', -12)
    if (this.config.showLineDatumValues) {
      let bbox = lineDatumValues.select('text').node().getBBox()
      lineDatumValues
        .select('rect')
        .attr(
          'fill',
          this.config.skin === 'dark' ? 'rgba(31, 31, 31, 0.8)' : 'rgba(255,255,255,0.8)'
        )
        .attr('width', bbox.width + 4)
        .attr('height', bbox.height)
        .attr('x', -bbox.width / 2 - 2)
        .attr('y', -12 - bbox.height / 2 - 5)
        .attr('rx', 2)
    }
  }
  getLegendData() {
    let legendData = {
      lines: [...this.data.lines],
      bars: this.cachedColorScale[1].isSinlge
        ? [{ id: this.data.bars.id, label: this.data.bars.id }]
        : [...this.data.bars],
    }
    legendData.lines.icon = 'line'
    legendData.bars.icon = 'square'
    legendData.bars.__forceDraw__ = true
    return legendData
  }
}
